import styled from "styled-components";
import * as u from "../utils";
import PreviewHover from "./PreviewHover";

export function MentionRead(props) {
  // console.log(`MentionRead:props`, props);
  const entity = props.contentState.getEntity(props.entityKey);
  const data = entity.getData();

  return (
    <PreviewHover type={"actor"} {...data}>
      <S.StaticSpan data-offset-key={props.offsetKey}>
        {props.decoratedText}
      </S.StaticSpan>
    </PreviewHover>
  );
}

export function mention() {
  return function strategy(block, cb, ctx) {
    const currFilter = (char) => {
      const key = char.getEntity();
      if (!key) return false;
      const type = ctx.getEntity(key).getType();
      return type === "MENTION";
    };

    block.findEntityRanges(currFilter, cb);
  };
}

const S = {};

S.Container = styled.span`
  color: rgba(98, 177, 254, 1);
  background-color: rgba(98, 177, 254, 0.2);
  border-radius: 3px;
  padding: 0px 2px;
  span {
    font-family:
      HK Grotesk,
      sans-serif;
  }
`;

S.StaticSpan = styled.span`
  color: ${u.colours.charcoal};
  font-weight: 700;
  cursor: pointer;
  span {
    font-family:
      HK Grotesk,
      sans-serif;
  }
`;
